import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChatMessageComponent, ChatMessageGroupComponent } from '@vendasta/galaxy/chat';
import { MatCardModule } from '@angular/material/card';
import { TemplatesService, TemplateType } from '@vendasta/templates';
import { Observable, tap } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'sms-builder-preview',
  templateUrl: 'text-message-builder-preview.component.html',
  styleUrls: ['./text-message-builder-preview.component.scss'],
  imports: [CommonModule, ChatMessageGroupComponent, ChatMessageComponent, MatCardModule],
})
export class TextMessageBuilderPreviewComponent implements OnChanges {
  @Input() messageText?: string;
  @Input() allowDynamic: boolean;
  rendered$: Observable<string>;
  loading = false;

  constructor(private readonly templates: TemplatesService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.allowDynamic) {
      this.loading = true;
      this.rendered$ = this.templates
        .render(
          changes['messageText'].currentValue,
          {
            account_group_id: 'want-fake-value-displayed',
            partner_id: 'want-fake-value-displayed',
            contact_id: 'want-fake-value-displayed',
          },
          TemplateType.TEMPLATE_TYPE_GOLANG_TEXT,
          {
            accountGroupId: 'account_group_id',
            partnerId: 'partner_id',
            contactId: 'contact_id',
          },
          undefined,
          undefined,
          undefined,
          true,
        )
        .pipe(tap((_) => (this.loading = false)));
    }
  }
}
